import React, { PureComponent } from "react";
import { IonRow, IonCol, IonPage, IonIcon, IonLoading } from "@ionic/react";
import SortingOptions from "../../../../../components/core/SortOptions/SortingOptions";
import { RecommendedError } from "../../../../../pages/Home/RecommendedError";
import "./SearchResults.page.scss";
import {
  searchResultsErrorText,
  searchResultsErrorButton,
  MODULES,
  Anywhere,
  PCmiler,
} from "../../../../../utils/constants";
import { EVENT, SCREEN, TAB } from "../../../../../utils/constants.analytics";
import { Search } from "../../../../../models/home/Search.model";
import { logEvent, setScreenName } from "../../../../../utils/Analytics";
import ToggleButton from "../../../../../web/components/toggle-button/ToggleButton";
import { RecentCard } from "../../../../../web/components/common/RecentCard";
import { LoadsList } from "../../../../../web/components/loads-list";
import {ShipmentMap} from "../../../../../web/components/pcmiler-map";
import { getSearchInputes } from "../../../../../web/containers/SearchContainer/searchUtility";
import {getSortOptions} from "../../../../../utils/SortOptions/SortOptions";
import ShowLoadCountBtn from "../../../../../web/components/ShowLoadCountBtn/ShowLoadCountBtn";
import { GoogleShipmentMap } from "../../../../../web/components/google-map";
import { IONICWrapper } from "../../../../../utils/common";
import { constructSearchParamsAfterBookLoad } from "app/pages/Execute/CarrierAssigned/shipmentPage.util";

class SearchResultPage extends PureComponent<any, any> {
  private pageSize = 25;
  private locationObj:any = undefined

  constructor(props: any) {
    super(props);
    this.state = {
      tab: true,
      showMap: false,
      editSearch: true,
      currentPage:  (this.props?.searchInput?.currentPage) || 0,
      sortDirection: (this.props?.searchInput?.sortDirection) || "asc",
      sortColumn: (this.props?.searchInput?.sortColumn) || "pickUpStartDate",
      sortColumnName: (this.props?.searchInput?.sortColumnName) || 'Pick-Up Date',
      shipmentToExpand: {},
      usePCmilerMaps: false
    };
  }

  componentDidMount() {
    setScreenName("screen_search_results");
    logEvent("ue_loads_search_scroll_view", { page: "search" });

    // Analytics implementation
    logEvent(EVENT.SV_SEARCH_RESULT, {
      screen: SCREEN.SEARCH_RESULT,
      lead: TAB.SEARCHED,
    });

    // ContentStack option to use PCmiler Maps or Google Maps
    const _usePCmilerMaps = IONICWrapper.details.keys 
      && IONICWrapper.details.keys.configuration.usePCmilerMaps 
        || PCmiler.usePCmilerMaps;
    const isPCmilerMaps = _usePCmilerMaps === "true" ? true : false;
    this.setState({ usePCmilerMaps: isPCmilerMaps });
  }

  setShowMap = (value: any) => value === "map";

  componentDidUpdate(prevProps: any) {
    if (
      this.props.searchInput &&
      JSON.stringify(this.props.searchInput) !==
        JSON.stringify(prevProps.searchInput) || 
        (JSON.stringify(this.props.results.searchLoads) !==
        JSON.stringify(prevProps.results.searchLoads) && 
        this.props.results.searchLoads.length === 0)
    ) {
      this.setState({ currentPage: 0});
    }
  }

  sortedData = (selectedValue: string, asc: boolean | undefined, sortColumnName: string) => {
    if (!this.props.isStof) {
      this.props.onResetPagination();
    }
    this.setState(
      {
        sortColumn: selectedValue,
        currentPage: 0,
        sortDirection: asc === true ? "asc" : "desc",
        sortColumnName
      },
      () => {
        if (this.props.isStof) {
          this.props.onSorting(selectedValue, asc === true ? "asc" : "desc");
        } else {
          this.searchData(false);
        }
        
      }
    );
  };

  navigate = () => {
    this.props.history.push({
      pathname: "/app/search",
      state: {
        segmenName:
          this.props.tabFrom === "favorite"
            ? "Favorite Search"
            : "Recent Search",
      },
    });
  };

  searchData = (isPagination: boolean) => {
    this.props.handleSortingPagination(
      getSearchInputes(
        this.props.searchInput || new Search(),
        this.props.userDetails,
        this.state.currentPage,
        this.state.sortColumn,
        this.state.sortDirection
      ),
      isPagination,
      false
    );
  };

  handleShowMore = () => {
    if (!this.props.isStof) {
      const { pageSize } = this;
      const totalRecords = this.props.totalRecords;
      const totalPages: number =
        parseInt(`${totalRecords / pageSize}`, 10) +
        (totalRecords % pageSize > 0 ? 1 : 0);
      const { currentPage } = this.state;

      if (totalRecords > pageSize && currentPage < totalPages - 1) {
        this.setState({ currentPage: currentPage + 1 }, () => {
          this.searchData(true);
        });
      }
    } else if (this.props.isStof == true) {
      this.props.onChangePage();
    }
  };
  handlerAfterBookLoad = () => {
    this.props.handleSortingPagination &&
      this.props.handleSortingPagination(
        getSearchInputes(
          this.props?.history?.location?.state?.isBookLoad? 
          constructSearchParamsAfterBookLoad(this.props?.shipmentDetailsAfterBookLoad,this?.props?.offSetValues):
           this.props?.history?.location?.state?.searchInput || new Search(),
          this.props.userDetails,
          0,
          this.state.sortColumn,
          this.state.sortDirection
        ),
        false,
        false
      );
    this.setState({
      currentPage: 0
    });
  };

  render() {

    const isShowSearchById = this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.searchById || false;

    const { detailObj } = this.props;
    if(detailObj){
      this.locationObj = {
        origin: detailObj.originCity,
        destination: detailObj.destinationCity
      }
    }
    const onChangeRowIndex = (rowIndex: number) => {
      setTimeout(() => {
        const pointer = document.getElementsByClassName("load-map-grid")[0];
        pointer && pointer.scrollIntoView();
      }, 2000);
    };
    const isStofLoading = (this.props.isStof || this.props.pathname == "/carrier/stof") && !!!this.props.isStofLoaded;

    if(isStofLoading){
      return (
          <IonLoading
            isOpen={isStofLoading}
            spinner={null}
            message={`<img src= 'assets/images/Schneider_Spinner-transparent.gif' className='loader-image' />`}
            show-backdrop={false}
            cssClass="loader-message"
        />
      );
    }
    const { origin, destination, pickUpEndDate, pickUpStartDate,dropEndDate, dropStartDate } = this.props.searchInput || this.locationObj || {};
    return (
      <IonPage className="desktop-page search-result-page">
        <div>
          {detailObj ? (
            <>
              <div className="back-btn">
                <span datatest-id="navigate-test" onClick={() => this.navigate()}>
                  {this.props.tabFrom === "favorite"
                    ? "Favorite Search"
                    : "Recent Search"}
                </span>
                <IonIcon src="assets/icon/chevron-forward-outline.svg" /> See
                Results
              </div>
              <RecentCard
                searchedDataParams={{
                  dropStartDate,
                  dropEndDate,
                  pickupEndDate:pickUpEndDate,
                  pickupStartDate:pickUpStartDate
                }}
                recentData={detailObj}
                disableBtn
                updateFlag={this.props.updateFlag}
                updateFavorite={this.props.updateFavorite}
                favoriteFlag={detailObj.favouritesearchindicator}
                isNetworkAvailable={this.props.isNetworkAvailable}
                showAlert={this.props.showAlert}
                onResultClick={() => {}}
              />
            </>
          ) : null}
        </div>

        <div className="search_results_container">
          <div className="sni-matched-wrapper sni-results-wrapper">
            <div className="results-title">Results</div>
            {this.props.showResult ? (
              <>
                {this.props.results &&
                this.props.results.searchLoads &&
                this.props.results.searchLoads.length ? (
                  <>
                    <IonRow className="matched-header">
                      <IonCol size="4">
                        <ToggleButton
                          handleChange={(value: string) => {
                            this.setState({ showMap: value == "map" });
                          }}
                          isMapActive={true}
                        />
                      </IonCol>
                      <IonCol size="8">
                        {!this.state.showMap && (
                          <div className="select_div">
                            <SortingOptions
                              options={
                                origin || destination
                                  ? getSortOptions(
                                      origin && origin !== Anywhere,
                                      destination && destination !== Anywhere
                                    )
                                  : getSortOptions(
                                      this.props.origin &&
                                        this.props.origin !== Anywhere,
                                      this.props.destination &&
                                        this.props.destination !== Anywhere
                                    )
                              }
                              sortedData={this.sortedData}
                              selectedOption={{
                                value: this.state.sortColumn,
                                name: this.state.sortColumnName,
                                sortDirection: this.state.sortDirection
                              }}
                              isSearchById={isShowSearchById ? this.props.history.location.state.searchById : false}
                            />
                          </div>
                        )}
                      </IonCol>
                    </IonRow>
                    <div className="total-load-count">
                      {this.props.totalRecords}
                      {this.props.totalRecords > 1 ? " Matches" : " Match"}
                    </div>
                    {!this.state.showMap ? (
                      <LoadsList
                      {...this.props}
                      {...this.locationObj}
                        origin={origin}
                        destination={destination}
                        shipmentToExpand={this.state.shipmentToExpand}
                        loads={this.props.results.searchLoads || []}
                        module={MODULES.SEARCH_RESULTS}
                        history={this.props.history}
                        isNetworkAvailable={this.props.isNetworkAvailable}
                        userDetails={this.props.userDetails}
                        buyLoadRequest={this.props.buyLoadRequest}
                        bookLoadStatus={this.props.bookLoadStatus}
                        getShipmentDetails={this.props.getShipmentDetails}
                        buyLoadStatusRemove={this.props.buyLoadStatusRemove}
                        buyLoadShipmentRequest={
                          this.props.buyLoadShipmentRequest
                        }
                        fetchShipments={this.props.fetchShipments}
                        toggleWatchLoad={this.props.toggleWatchLoad}
                        carrierLoads={this.props.carrierLoads}
                        handlerAfterBookLoad={this.handlerAfterBookLoad}
                        removeRecommendedResults={
                          this.props.removeRecommendedResults
                        }
                        removewatchedResults={this.props.removewatchedResults}
                        isCarrierLoad={false}
                        onChangeRowIndex={onChangeRowIndex}
                        searchInput={{
                          ...this.props.searchInput,
                          currentPage: this.state.currentPage,
                          sortColumn: this.state.sortColumn,
                          sortDirection: this.state.sortDirection,
                          sortColumnName: this.state.sortColumnName
                        }}
                      />
                    ) : (
                          this.state.usePCmilerMaps ? (
                            <ShipmentMap
                              shipments={this.props.results.searchLoads || []}
                              onCloseMapView={(shipment: any) => {
                                this.setState({
                                  showMap: false,
                                  shipmentToExpand:
                                    (shipment && shipment.shipment) || {},
                                });
                              }}
                            />) : (
                            <GoogleShipmentMap
                              shipments={this.props.results.searchLoads || []}
                              onCloseMapView={(shipment: any) => {
                                this.setState({
                                  showMap: false,
                                  shipmentToExpand:
                                    (shipment && shipment.shipment) || {},
                                });
                              }}
                            />)
                    )}
                    {this.props.results.searchLoads.length ===
                      this.props.totalRecords ? (
                      <p className="end_of_list">End of list</p>
                    ) : (
                      !this.props.isStof ? 
                      (<ShowLoadCountBtn
                        onShowMore={this.handleShowMore}
                        shouldShowLoadMoreUpdate={this.props.shouldShowLoadMoreUpdate}
                        totalRecords={this.props.totalRecords}
                        currentPage={this.state.currentPage }
                        pageSize={this.pageSize}
                      />)
                      :
                      (<ShowLoadCountBtn
                        onShowMore={this.handleShowMore}
                        shouldShowLoadMoreUpdate={this.props.shouldShowLoadMoreUpdate}
                        totalRecords={this.props.totalRecords}
                        currentPage={this.props.stofCurrentPage}
                        pageSize={this.props.stofPageSize}
                      />)
                    )}
                  </>
                ) : (
                  <div className="searchResultsError">
                    <RecommendedError
                      data-test="rec-error"
                      constantText={searchResultsErrorText}
                      constantButton={searchResultsErrorButton}
                    />
                  </div>
                )}
              </>
            ) : (
              <span>Add search criteria to see results</span>
            )}
          </div>
        </div>
      </IonPage>
    );
  }
}
export default SearchResultPage;
